// extracted by mini-css-extract-plugin
module.exports = {"chat-drop-down":"ChatDropDown_chat-drop-down__OWTLV"};